import { memo, useMemo } from "react";

const STROKE = "#5588ff";

type Segment = { x1: number; y1: number; x2: number; y2: number };

function fmt(n: number): string {
    const s = n.toFixed(2);
    return s.replace(/\.?0+$/, "") || "0";
}

function segmentsToPathD(segments: Segment[]): string {
    let d = "";
    for (let i = 0; i < segments.length; i++) {
        const s = segments[i];
        d += `M${fmt(s.x1)} ${fmt(s.y1)}L${fmt(s.x2)} ${fmt(s.y2)}`;
    }
    return d;
}

/**
 * Flow debug: one stroked path for all vectors + single arrow marker (avoids N gradients / N lines).
 */
export const FlowDebugSegmentLines = memo(function FlowDebugSegmentLines({
    segments,
    strokeWidth,
    gradientIdPrefix,
}: {
    segments: Segment[];
    strokeWidth: number;
    /** Unique prefix for defs ids (e.g. when multiple SVGs exist). */
    gradientIdPrefix: string;
}) {
    const arrowId = `${gradientIdPrefix}-arrow`;
    const d = useMemo(() => segmentsToPathD(segments), [segments]);

    if (!d) return null;

    return (
        <>
            <defs>
                <marker
                    id={arrowId}
                    viewBox="0 0 3 3"
                    refX={2.6}
                    refY={1.5}
                    markerWidth={3.5}
                    markerHeight={3.5}
                    orient="auto"
                    markerUnits="strokeWidth"
                >
                    <path d="M0,0 L3,1.5 L0,3 Z" fill={STROKE} />
                </marker>
            </defs>
            <path
                d={d}
                fill="none"
                stroke={STROKE}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                markerEnd={`url(#${arrowId})`}
            />
        </>
    );
});
